import Swal from "sweetalert2";
import { actualizarDatos } from "../../api/common";


export const CancelarProgramacion = async (id, userData, setRefresh, refresh,setIsOpen, setModalSpinner) => {
  console.log("Iniciando cancelación de programación:", id);

  const result = await Swal.fire({
    title: "¿Deseas cancelar la programación?",
    text: "Esta acción cancelará todos los ítems de este listado que tengan estado NO FINALIZADO.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sí, Cancelar",
    cancelButtonText: "No, Volver",
  });

  if (result.isConfirmed) {
    try {
      setModalSpinner(true)
      const payload = {
        tipoAtualizacion: "CANCELAR_PROGRAMACION",
        _id: id,
        estado: "CANCELADO",
        fechaCancelado: new Date(),
        responsableCancelacion: userData._id,
      };

      const response = await actualizarDatos("Programacion", payload, id);

      if (response.status === 200) {
        Swal.fire("Cancelada", "La programación ha sido cancelada correctamente.", "success");
        setRefresh(!refresh); // Refresca la lista
        setModalSpinner(false)
        setIsOpen(false)
      } else {
        setModalSpinner(false)
        Swal.fire("Error", "No se pudo cancelar la programación.", "error");
      }
    } catch (error) {
      setModalSpinner(false)
      console.error("Error al cancelar la programación:", error);
      Swal.fire("Error", "Hubo un problema al cancelar la programación.", "error");
    }
  }
};

